module.exports = __webpack_public_path__ + "static/img/image_content.2653643.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/votefriend/images/image_content.png
// module id = 2977
// module chunks = 1